// extracted by css-extract-rspack-plugin
module.exports =  {"tableHead":"BundlesSection__tableHead___VCbH_","quantityTableHeader":"BundlesSection__quantityTableHeader___FXUCg"};